<template>
  <div class="transition">
    <div
      class="flex cursor-pointer items-center justify-between p-2 pr-4"
      data-testid="rx-sum-bar"
      @click="toggle"
    >
      <div class="flex items-center gap-2">
        <LazyIconFielmannChevronUp
          class="size-6 transition"
          :class="{ '-rotate-180': isOpen }"
        />
        <Headline tag="span" look="h4">
          {{ title }}
        </Headline>
      </div>
      <div class="flex gap-4">
        <Headline tag="span" look="h4" weight="normal" class="text-shade-400">
          {{ $t('rx.total') }}
        </Headline>
        <Headline tag="span" look="h4">
          <ProductPriceLegacy
            v-if="totalPrice"
            :price="totalPrice"
            align="right"
          />
        </Headline>
      </div>
    </div>
    <div
      class="overflow-hidden transition-height"
      :style="isOpen ? { height: contentHeight } : { height: 0 }"
    >
      <div ref="content" class="flex flex-col pb-2">
        <div
          v-for="(item, key) in details"
          :key="`item-${key}`"
          :class="{ 'text-shade-400': item.alternate }"
        >
          <div class="flex justify-between py-1 pl-10 pr-4">
            <span>{{ item.title }}</span>
            <span class="text-right text-[15px]">
              <template v-if="item.price?.withTax == 0">
                {{ $t('pdp.glasses.inclusive') }}
              </template>
              <template v-else-if="item.price?.withTax">
                <ProductPriceLegacy :price="item.price" type="whisper" />
              </template>
              <template v-else> – </template>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useElementSize } from '@vueuse/core'
import type { ISumBarDetails } from './ISumBar'
import type { Price } from '@scayle/storefront-nuxt'

defineProps({
  title: {
    type: String,
    required: true,
  },
  totalPrice: {
    type: Object as PropType<Price>,
    required: true,
    default: () => {},
  },
  details: {
    type: Array as PropType<ISumBarDetails[]>,
    required: true,
  },
})

/* toggle slide effect */
const emit = defineEmits(['toggle'])

const content = useTemplateRef('content')
const isOpen = ref(false)

const toggle = () => {
  isOpen.value = !isOpen.value
  emit('toggle', isOpen.value)
}

const { height } = useElementSize(
  content,
  { width: 0, height: 0 },
  { box: 'border-box' },
)
const contentHeight = computed(() => `${height.value || 0}px`)
</script>
